import React, { Component } from 'react'
import "../../css/general-style.css"
import '../../css/small-table-responsive.css'

import DashModalV2 from '../DashModalV2';
import { DateFormatMAS90,DeleteQueryFormat } from '../../functions/dateFormat';



export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();

    }
    state = {
        Title:'',
        Data:[],
        showModal1:false,
        OnHand:'',
        Descrip:''
    }

    getSpecificData(title,data,onHand,descrip){
        this.setState({
            Title:title,
            Data:data,
            OnHand:onHand,
            Descrip:descrip
        })
        this.handleModalOpen("showModal1")
    }

    handleModalOpen = (modal) => {

        this.setState({ [modal]: true })
    }

    handleModalClose = (modal) => {
        this.setState({ [modal]: false })
        this.clearState()
    }

    clearState(){
        this.setState({
            Title:'',
            Data:[]  
        })
    }



    render() {
        return (
            <>
                <div className='card'>
                    <div className='card-body'>
                        <div className='row '>
                            <div className='col-sm-6'>
                                <h6 className='card-title-clean mb-0'>{this.props.Title}</h6>
                            </div>
                            <div className='col-sm-12'>
                                <div className='tableFixHeadSmall'>
                                <table className='table table-clean'>
                                    <thead>
                                        <tr>
                                            <th>Item Code</th>
                                            <th>Description</th>
                                            <th>Short</th>
                                            <th>On Hand</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(this.props.data).map((key, k) => (
                                            <tr onClick={()=>this.getSpecificData(key,this.props.data[key].detail,this.props.data[key].TotalQuantityOnHand,this.props.data[key].ItemCodeDesc)} key={k}>
                                                <td>{key}</td>
                                                <td>{this.props.data[key].ItemCodeDesc}</td>
                                                <td>{this.props.data[key].shorts.total}</td>
                                                <td>{this.props.data[key].TotalQuantityOnHand}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <DashModalV2
                    title={this.state.Title}
                    subtitle={this.state.Descrip + (this.state.OnHand !== undefined ? `  ·  On Hand: ${this.state.OnHand}` : '')}
                    show={this.state.showModal1}
                    onClose={() => this.handleModalClose('showModal1')}
                >
                    <div className="tableFixHeadSmall">
                        <table className='table table-clean'>
                            <thead>
                                <tr>
                                    <th>Invoice No</th>
                                    <th>Customer No</th>
                                    <th>Customer Name</th>
                                    <th>Invoice Date</th>
                                    <th>Last PO Date</th>
                                    <th>Route</th>
                                    <th className='text-center'>Qty Ordered</th>
                                    <th className='text-center'>Qty Shipped</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.Data.map((order, o) => (
                                    <tr key={o}>
                                        <td>{order.InvoiceNo}</td>
                                        <td>{order.CustomerNo}</td>
                                        <td>{order.BillToName}</td>
                                        <td>{DateFormatMAS90(order.InvoiceDate)}</td>
                                        <td>{DateFormatMAS90(DeleteQueryFormat(order.LastPODate))}</td>
                                        <td>{order.UDF_RUTA}</td>
                                        <td className='text-center'>{order.QuantityOrdered}</td>
                                        <td className='text-center'>{order.QuantityShipped}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </DashModalV2>
            </>
        )
    }
}
